(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gould-cellular"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gould-cellular'))customElements.define('gould-cellular',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    const v=this.querySelector('video'),b=this.querySelector('button');
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.manualPause=false;this.visible=false;
    v.muted=true;v.controls=false;b.hidden=false;
    const sync=()=>{b.textContent=v.paused?b.dataset.play:b.dataset.pause;b.setAttribute('aria-pressed',String(!v.paused))};
    const play=()=>v.play().catch(sync);
    v.addEventListener('play',sync);v.addEventListener('pause',sync);v.addEventListener('error',()=>{b.hidden=true});
    b.addEventListener('click',()=>{if(v.paused){this.manualPause=false;play()}else{this.manualPause=true;v.pause()}});
    this.onMotion=()=>{if(this.motion.matches)v.pause();else if(this.visible&&!this.manualPause)play()};
    this.motion.addEventListener('change',this.onMotion);
    this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible&&!this.motion.matches&&!this.manualPause)play();else v.pause()},{threshold:.15});
    this.observer.observe(this);sync();
  }
  disconnectedCallback(){this.observer?.disconnect();if(this.motion)this.motion.removeEventListener('change',this.onMotion);this.querySelector('video')?.pause();this.ready=false}
});
  } catch(e) { console.error(e); }
})();

})();
